<div class="container-fluid">
  <div class="policy-detail" *ngIf="policy as p">
  <div class="mb-3">
    <div class="d-flex align-items-center gap-2">
      <a
        [routerLink]="['/policies', family]"
        class="back-btn"
        title="Back to {{ familyLabel() }} policies"
        aria-label="Back to {{ familyLabel() }} policies"
      >
        <i class="bi bi-arrow-left"></i>
      </a>
      <h1 class="h3 mb-0">{{ p.name }}</h1>
    </div>
    <div class="text-muted mt-1">
      <code>{{ p.masterId }}</code>
      <span class="badge ms-2" [ngClass]="statusBadgeClass(p.status)">{{ p.status }}</span>
      <span class="ms-2">v{{ p.version ?? '—' }}</span>
    </div>
  </div>

  <dl class="row small text-muted mb-4">
    <dt class="col-sm-2">Created</dt>
    <dd class="col-sm-4">{{ p.createdBy?.name ?? '—' }} · {{ p.createdAt ? (p.createdAt | date: 'dd-MM-yyyy') : '—' }}</dd>
    <dt class="col-sm-2">Published</dt>
    <dd class="col-sm-4">
      {{ p.publishedBy?.name ?? '—' }} · {{ p.publishedAt ? (p.publishedAt | date: 'dd-MM-yyyy') : '—' }}
    </dd>
  </dl>

  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs mb-3">
    <li [ngbNavItem]="'published'">
      <a ngbNavLink>Published</a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th *ngFor="let col of columns">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of $any(p.items)">
                <td *ngFor="let col of columns">
                  <ng-container [ngSwitch]="col.type">
                    <span *ngSwitchCase="'boolean'">{{ cellValue(item, col) ? 'Yes' : 'No' }}</span>
                    <span *ngSwitchCase="'date'">{{
                      cellValue(item, col) ? (cellValue(item, col) | date: 'dd-MM-yyyy') : '—'
                    }}</span>
                    <span *ngSwitchCase="'array'">{{ formatArrayValue(cellValue(item, col)) }}</span>
                    <span *ngSwitchDefault>{{ cellValue(item, col) ?? '—' }}</span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-muted" *ngIf="!p.items.length">No items on this policy.</div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="'coverage'" [disabled]="true">
      <a ngbNavLink title="Coverage isn't implemented on the backend yet">Coverage</a>
    </li>
    <li [ngbNavItem]="'versions'" [disabled]="true">
      <a ngbNavLink title="Versions isn't implemented on the backend yet">Versions</a>
    </li>
    <li [ngbNavItem]="'simulate'" [disabled]="true">
      <a ngbNavLink title="Simulate isn't implemented on the backend yet">Simulate</a>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>

<a *ngIf="!policy && !loading && !errorMessage" [routerLink]="['/policies', family]" class="back-link mb-2">
  <i class="bi bi-arrow-left"></i>
  <span>Back to {{ familyLabel() }} policies</span>
</a>

<app-loading *ngIf="loading" [overlay]="false" size="small" message="Loading policy…"></app-loading>

<div class="alert alert-danger d-flex justify-content-between align-items-center" *ngIf="errorMessage">
  <span>{{ errorMessage }}</span>
  <button type="button" class="btn btn-outline-danger btn-sm" (click)="retry()">Retry</button>
</div>
</div>
